import React from 'react';

const CategoryHero = ({ title, description }) => {
  return (
    <div className="description">
      <div className="page__hero">
        <h1 className="heading--xl">
          {title}
        </h1>
        <div className="content">
          <p dangerouslySetInnerHTML={{ __html: description }}></p>
        </div>
      </div>
    </div>
  )

}
export default CategoryHero
